export interface Language {
  code: string;
  label: string;
}

export default class AcceptedLanguageEnum {
  static readonly languages: Language[] = [
    { code: 'uk', label: 'Українська' },
    { code: 'en', label: 'English' },
    { code: 'pl', label: 'Polski' },
    { code: 'es', label: 'Español' },
    { code: 'fr', label: 'Français' },
    { code: 'de', label: 'Deutsch' },
    { code: 'it', label: 'Italiano' },
    { code: 'pt', label: 'Português' },
    { code: 'zh', label: '中文' },
    { code: 'ja', label: '日本語' },
    { code: 'ko', label: '한국어' },
    { code: 'ar', label: 'العربية' },
    { code: 'hi', label: 'हिन्दी' }
  ];

  static get list() {
    return AcceptedLanguageEnum.languages.map(lang => lang.code);
  }

  static getLabel(code: string): string {
    const language = AcceptedLanguageEnum.languages.find(lang => lang.code === code);
    return language?.label || code;
  }

  static isSupported(code: string): boolean {
    return AcceptedLanguageEnum.languages.some(lang => lang.code === code);
  }
}
